import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  CircularProgress,
  Pagination,
  Alert
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ListItemPetFood from './ListItemPetFood';
import { fetchReport, handleError } from '../../utils/lib';
import { useSnackbar } from '../../providers/SnackBarProvider';
import { useConfig } from '../../providers/ConfigProvider';

const LowFoodReport = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const snackbar = useSnackbar();
  const config = useConfig();

  useEffect(() => {
    fetchLowFood(page);
  }, [page]);

  const fetchLowFood = async (pageNumber) => {
    setIsLoading(true);
    try {
      const response = await fetchReport('LOW_FOOD', pageNumber);
      setData(response);
    } catch (error) {
      handleError(error, snackbar);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (!data || !data.content || data.content.length === 0) {
    return (
      <Box textAlign="center" p={3}>
        <Typography variant="body1">{t('reports.noLowFood')}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">
          {t('reports.lowFoodTitle')} ({data.total_results || data.content.length})
        </Typography>
      </Box>

      <Box mb={3}>
        <Typography variant="caption" color="text.secondary">
          {config?.vet?.pet_naming_es_plural || 'Mascotas'} con niveles bajos de alimento / pienso. Se computan ventas de los últimos 60 días para {config?.vet?.pet_naming_es_plural.toLowerCase() || 'mascotas'} que tienen registrado peso, raza y productos de categorías de alimentos / pienso que utilizan unidades complejas (u/kg por ejemplo).
        </Typography>
      </Box>

      {data.content && data.content.map((pet) => (
        <ListItemPetFood
          key={pet.id}
          pet={pet}
        />
      ))}

      {data.total_pages && data.total_pages > 1 && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={data.total_pages}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default LowFoodReport; 